// @ts-strict-ignore
import { ComplexProjectVO, ProjectVO } from './project.vo';
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('IEKBuildingBlockVO')
export class IEKBuildingBlockVO {

  @JsonProperty('name', 'String')
  public name: string = undefined;

  @JsonProperty('type', 'String')
  public type: string = undefined;

  @JsonProperty('usePENBridge', 'Boolean')
  public usePENBridge: boolean = undefined;

  @JsonProperty('useSeparationPlate', 'Boolean')
  public useSeparationPlate: boolean = undefined;
}

@JsonObject('BuildingBlockHeadVO')
export class BuildingBlockHeadVO {

  @JsonProperty('id', 'Number')
  public id: number = undefined;

  @JsonProperty('name', 'String')
  public name: string = undefined;
}

@JsonObject('BuildingBlockVO')
export class BuildingBlockVO extends BuildingBlockHeadVO {

  @JsonProperty('complexProjectVO', 'ComplexProjectVO')
  public complexProjectVO: ComplexProjectVO = undefined;
}

@JsonObject('BuildingBlockSaveResponseVO')
export class BuildingBlockSaveResponseVO {
  @JsonProperty('statusCode', 'Number')
  public statusCode: number = undefined;

  @JsonProperty('savedProject', 'ProjectVO')
  public savedProject: ProjectVO = undefined;
}

@JsonObject('BuildingBlockSaveDTO')
export class BuildingBlockSaveDTO {

  @JsonProperty('id', 'Number')
  public id: number = undefined;

  @JsonProperty('name', 'String ')
  public name: string = undefined;

  @JsonProperty('projectId', 'Number')
  public projectId: number = undefined;

  @JsonProperty('project', 'ProjectVO')
  public project: ProjectVO = undefined;

  constructor(id?: number, name?: string, projectId?: number, project?: ProjectVO) {
    this.id = id;
    this.name = name;
    this.projectId = projectId;
    this.project = project;
  }
}

export interface BuildingBlockAssistantSearchParams {
  type: string;
  actuationType: string;
  wireCrossSection?: number;
  currentType: string;
  protectiveDevice?: string;
  useNDisconnect?: boolean;
  busbarCrossSection?: number;
  numberOfConnectionPoints?: number;
}
